import { handleError } from 'common/utils/app.utils';
import React, { MouseEventHandler, useState } from 'react';
import { EDIT_CART_ACTION, getBulkEditRequest } from '../configure-plan-pricing-constant';
import { doBulkEditAction } from '../configure-plan-pricing.service';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import ServicesDropdown from 'dedicated/components/choose-plan/servicesDropdown/servicesDropdown';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './contract-period.scss';
import { getServiceOptions, getServiceType, getTotalLinks } from './formControl.service';

type Props = {
  hidePopup: MouseEventHandler;
  records: Array<any>;
  reFetchRecords: Function;
  onConfigSiteWithExcel: Function;
};

export const ChangeServiceType = ({ hidePopup, records, reFetchRecords, onConfigSiteWithExcel }: Props) => {
  const [selectedserviceOption, setSelectServiceOption] = useState<any>(getServiceType(records));
  const [loader, setLoader] = useState<boolean>(false);
  const [showTooltip, setShowToolTip] = useState<boolean>(false);

  const submitService = () => {
    setLoader(true);
    const requestParam = getBulkEditRequest(EDIT_CART_ACTION.EDIT_SERVICE_TYPE, records, selectedserviceOption?.value);
    doBulkEditAction(requestParam).then(
      (response: any) => {
        setLoader(false);
        reFetchRecords?.();
        hidePopup?.(false as any);
      },
      (err: any) => {
        setLoader(false);
        handleError(err);
      }
    );
  };

  const setServiceOnChange = (value: any) => {
    setSelectServiceOption(value);
  };

  const setTooltip = () => {
    setShowToolTip(!showTooltip);
  };

  const onEditExcel = () => {
    hidePopup?.(false as any);
    onConfigSiteWithExcel();
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder contractPeriod">
        <h2 className="cancel-head">Change Service Type</h2>
        <p className="contract-message">
          <span> {getTotalLinks(records)} selected links</span> will be updated as per the selection below.
        </p>

        <div className="select_info">
          {selectedserviceOption && (
            <div className="tooltip_wrap">
              <h3 className="type-service">
                Type of Service
                <span className="material-icons-outlined" onClick={setTooltip}>
                  info
                </span>
                {showTooltip && <ServicesDropdown setShowManageServices={setTooltip} />}
              </h3>
            </div>
          )}
        </div>
        <div className="radio_box">
          <RadioGroup options={getServiceOptions()} value={selectedserviceOption} onChange={setServiceOnChange} />
        </div>
        <div className="characters">&nbsp;</div>
        <p className="note">
          * Please note that standard routers will be auto-selected for managed service type. In case you need to change the router, please{' '}
          <span onClick={onEditExcel}>edit with excel</span>.
        </p>
        <div className="buttonSection">
          <Button type="button" variant="outlinebtn" onClick={hidePopup}>
            Cancel
          </Button>
          <Button type="button" disabled={loader} onClick={submitService}>
            Change
            {loader && <span className="loading_icon"></span>}
          </Button>
        </div>
      </div>
    </div>
  );
};
